const searchInHeaders = document.querySelectorAll('theme-header search-form-header');
const mainContent = document.querySelector('#main-content');
let isSearchPageContentLive = false;
let typingTimeout;

const searchInHeaderInit = () => {
	searchInHeaders.forEach(searchInHeader => {
		const searchInput = searchInHeader.querySelector('input.search-field');
		if (!searchInput) return;
		searchInput.addEventListener('keyup', (e) => {
			clearTimeout(typingTimeout); // Clear any existing timeout
			typingTimeout = setTimeout(() => searchInputChange(e), 300); // Trigger after 300ms
		});
	})
}

const searchInputChange = (e) => {
	const currSearchInput = e.target;
	if (!currSearchInput) return;

	const currValue = currSearchInput.value.trim();
	const currentURL = new URL(window.location.href);

	if (currValue.length > 2) {
		const searchQuery = encodeURIComponent(currValue);

		currSearchInput.addEventListener('blur', (event) => {
			window.location.href = `/search?q=${searchQuery}`;
		});

		if (currentURL.pathname === '/search') {
			currentURL.searchParams.set('q', searchQuery);
			window.history.replaceState({}, '', currentURL.toString());
			isSearchPageContentLive = true;
			renderSearchPageDynamically(searchQuery);

		} else {
			const searchPageURL = `/search?q=${searchQuery}`;
			window.history.pushState({}, '', searchPageURL);
			renderSearchPageDynamically(searchQuery);
		}

	}
	else if (currValue.length === 0) window.location.href = '/';
};

const renderSearchPageDynamically = async (searchQuery, searchPageLive) => {
	const parser = new DOMParser();

	try {
		const searchPageResponse = await fetch(`/search?q=${searchQuery}`);
		if (!searchPageResponse) return;
		if (searchPageResponse?.status !== 200 && searchPageResponse?.ok !== true) return;
		const contentType = searchPageResponse.headers.get('Content-Type');
		if (contentType.includes('text/html')) {
			const searchPageData = await searchPageResponse.text();
			if (!searchPageData) return;
			const searchPageHtml = parser.parseFromString(searchPageData, "text/html");
			const searchPageMainFullContent = searchPageHtml.querySelector('#main-content');
			const currentMainContent = document.querySelector('#main-content')

			if (!searchPageMainFullContent) return;
			if (isSearchPageContentLive) {
				if (!currentMainContent) return;
				const currentMainContentSearchContent = currentMainContent.querySelector('.row.search-main-content');
				const searchPageMainRowContent = searchPageMainFullContent.querySelector('.row.search-main-content');
				if (!currentMainContentSearchContent && !searchPageMainFullContent) return;

				const currentMainSearchFound = currentMainContent.querySelector('.template-header--description');
				const searchPageSearchFound = searchPageMainFullContent.querySelector('.template-header--description');
				if (!currentMainSearchFound && !searchPageSearchFound) return;


				currentMainContentSearchContent.innerHTML = searchPageMainRowContent.innerHTML;
				currentMainSearchFound.innerHTML = searchPageSearchFound.innerHTML;

			}
			else {
				mainContent.innerHTML = searchPageMainFullContent.innerHTML;
			}


		}
	}
	catch (err) {
		console.warn("err:", err)
	}

}

const renderSearchPageContentDynamically = () => {

}

setTimeout(() => {
	if (searchInHeaders && mainContent) searchInHeaderInit();
}, 100);

